import React, { Component } from "react";
import DatePicker from "react-datepicker";

export const SecureDirectoryClientInformationDetail =

	class extends Component {

		render() {
			return (
				<div>
					{this.renderForm()}
				</div>
			);
		}

		renderForm() {
			const { solicitacao } = this.props;

			return(
				<>
					{ (solicitacao.ipsInternet || solicitacao.nomeSo) &&
					<>
						<div className="mt-4 mb-4">
							<h2 ref={this.arquivosRef}>Pasta Segura</h2>
						</div>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="ipsInternet">IP's de Internet:</label>
										<input type="text" name="ipsInternet" 
											value={solicitacao.ipsInternet}  
											readOnly />
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="so">Sistema operacional da pasta segura:</label>
										<input type="text" name="nomeSo"  readOnly
												value={solicitacao.nomeSo ? solicitacao.nomeSo : ""}
											/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
                            <div className="col-md">
                                <div className="field">
                                    <div className="input">
                                        <label htmlFor="nomePastaSegura">Nome da Pasta Segura:</label>
                                        <input type="text" name="nomePastaSegura" 
                                            value={solicitacao.nomePastaSegura}  
                                            readOnly/>
                                    </div>
                                </div>
                            </div>
							<div className="col-md">
                                <div className="field">
                                    <div className="input">
                                        <label htmlFor="andamentoImplantacao">Informações do Andamento da implantação da Pasta Segura:</label>
                                        <textarea type="text" name="andamentoImplantacao" 
                                            value={solicitacao.andamentoImplantacao}
											readOnly/>
                                    </div>
                                </div>
                            </div>
						</div> 

						<div className="row">
							<div className="col-md">
                                <div className="field">
                                    <div className="input">
                                        <label htmlFor="dataConclusaoImplantacao">Data da Conclusão da Implantação:</label>
										<DatePicker 
											locale="pt_br" 
											dateFormat="dd/MM/yyyy" 
											readOnly
											selected={solicitacao.dataConclusaoImplantacao} 
											disableClock={true}
											/>
                                    </div>
                                </div>
                            </div>
                        </div>
					</>
				}
				</>
			);
		}

	}
	
